
const searchForm = document.querySelector('.search__form');

searchForm.addEventListener("click", () => { isSearchArea() });
searchForm.addEventListener("keydown", () => { isSearchArea() });

function isSearchArea() {
    // Do this instead
    var cont = 0;
    var myInterval = setInterval( isSearch, 100);
    
    function myStopFunction() {
        clearInterval(myInterval);
    }

    function isSearch(){
        cont++;
        //console.log('test ' + cont);
        const searchArea = document.querySelector('.klevuSearchResultsC');
        const displayState = getComputedStyle(searchArea).display;
        if (displayState == 'flex') {
            searchHeader(1);
            myStopFunction();
            //console.log(displayState);
        } else if ( (displayState != 'flex' && cont > 2) || cont > 20 ) {
            myStopFunction();
            searchHeader(0);
            //console.log('no search');
        }
    }

}

function searchHeader(state) {
    //console.log(state);
    if(state == 1){
        document.querySelector('.header').classList.add('search-active');
    } else {
        document.querySelector('.header').classList.remove('search-active');
    }
}